import React, { Component } from 'react';
import styles from "./DotLoaderStyles.module.scss";
import GCLogoWhite from "images/gc-logo-white.png";
import GCLogoBlack from "images/gc-logo-black.png";

class DotLoader extends Component {

    constructor(props) {
        super(props);

        this.state = {

        };
    }

    render() {
        return (
            <>
                <img src={GCLogoBlack} className={styles.logo } alt="GameCity Logo" />
                <div class={`${styles["dot-loader"]} ${styles[this.props.size] || styles.medium} ${styles[this.props.variant] || styles.light}`}>
                    <span className={styles.dot}></span>
                    <span className={styles.dot}></span>
                    <span className={styles.dot}></span>
                </div>
            </>
        );
    }
}

export default DotLoader;

